export class SessionAttendeePassOrFailConstants{
    public static readonly AttendeeStatus_Pass: string = 'Pass';
    public static readonly AttendeeClassName_Pass: string = 'pass';
    public static readonly AttendeeStatus_Fail: string = 'Fail';
    public static readonly AttendeeClassName_Fail: string = 'fail';
}
